<template>
  <v-card
      elevation="0"
      style="width: 840px; margin-right: 140px"
  >
    <v-card-title
        class="login-history-title"
    >
      {{ $t('loginHistory.title') }}
    </v-card-title>
    <v-card-text style="padding: 0">
      <v-col cols="16">
        <login-history-main-table />
      </v-col>
    </v-card-text>
  </v-card>
</template>

<script>

import LoginHistoryMainTable from '@/components/loginHistory/LoginHistoryMainTable.vue'
export default {
  name: 'LoginHistory',

  components: {
    LoginHistoryMainTable
  }
}
</script>

<style>
.login-history-title {
  font-weight: 400;
  font-size: 24px;
  line-height: 108%;
  color: #2B2B2B;
  padding: 0;
  margin-left: 12px;
  margin-bottom: 12px;
}
</style>